import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {UseLoader} from "../../../hooks/useLoader";

import {confirmDialog} from "primereact/confirmdialog";

import {guardarDeducion} from "../../../api/deduccion.service";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {error} from "../../../shared/utils/utils";
import NumberFormat from "react-number-format";


export const ModalNuevoDeduccion = ({show, hide}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [mostrarValor, setMostrarValor] = useState(false);
    const [mostrarPorcentaje, setMostrarPorcetaje] = useState(false);

    const initParams = {
        descripcion: "",
        descA: "",
        porcentaje: "",
        orden: "",
        estado: "",
        tipo: "",
        valor: ''
    };
    const [field, setField] = useState(initParams);



    const onSubmit = e => {
        try {
            e.preventDefault();
            if (
                field.descripcion === ''
                || field.descA === ''
                || field.orden === ''
                || field.estado === ''
                || field.tipo === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            if (field.tipo === 'M') {
                if (
                    field.valor === ''
                ) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Validar campo porcentaje",
                        life: 3000
                    });
                    return;
                }
            } else if (field.tipo === 'F') {
                if (
                    field.porcentaje === ''
                ) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Validar campo porcentaje",
                        life: 3000
                    });
                    return;
                }

            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true);
                    const response = await guardarDeducion(field);
                    const data = await response.data;
                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    setField(initParams);
                    hide()
                }
            });
        } catch (e) {
            handleLoader(false);
            console.log(e)
        }
    }

    const onChangeTipo = (value) => {
        if (value === 'M') {
            setMostrarValor(true);
            setMostrarPorcetaje(false);
        } else if(value === 'F'){
            setMostrarValor(false);
            setMostrarPorcetaje(true);
        } else {
            setMostrarValor(false);
            setMostrarPorcetaje(false);
        }
        setField({...field, tipo: value})
    }

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo item para deducciones" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información de deducción
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descr"
                                    >
                                        Descripcion *
                                    </label>
                                    <textarea
                                        name="desc"
                                        className="form-input-small"
                                        value={field.descripcion}
                                        onChange={(e) => setField({...field, descripcion: e.target.value})}
                                        id="desc" rows="1">
                                </textarea>
                                    {error(field.descripcion, 'required')}
                                    {error(field.descripcion, 'maxLength', 100)}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descA"
                                    >
                                        Descripcion abrev *
                                    </label>
                                    <input
                                        id="descA"
                                        type="text"
                                        className="form-input-small"
                                        value={field.descA}
                                        onChange={(e) => setField({...field, descA: e.target.value})}
                                    />
                                    {error(field.descA, 'required')}
                                    {error(field.descA, 'maxLength', 40)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="orden"
                                    >
                                        Orden *
                                    </label>
                                    <input
                                        id="orden"
                                        type="number"
                                        className="form-input-small"
                                        value={field.orden}
                                        onChange={(e) => setField({...field, orden: e.target.value})}
                                    />
                                    {error(field.orden, 'required')}
                                    {error(field.orden, 'maxLength', 6)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipocuen"
                                    >
                                        Tipo *
                                    </label>
                                    <select
                                        className="form-input-small"
                                        value={field.tipo}
                                        onChange={(e) => onChangeTipo(e.target.value)}
                                        id="tipocuen">
                                        <option value="">seleccione</option>
                                        <option value="M">Manual</option>
                                        <option value="F">Formulado</option>
                                    </select>
                                    {error(field.tipo, 'required')}
                                </ContainerGroupForm>

                                {mostrarPorcentaje && <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="porcentaje"
                                    >
                                        Porcentaje *
                                    </label>
                                    <input
                                        value={field.porcentaje}
                                        onChange={(e) => setField({...field, porcentaje: e.target.value})}
                                        id="porcentaje"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {error(field.porcentaje, 'required')}
                                    {error(field.porcentaje, 'maxLength', 11)}
                                </ContainerGroupForm>}

                                {mostrarValor &&  <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="porcentaje"
                                    >
                                        Valor *
                                    </label>
                                    <NumberFormat
                                        id="valor"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input-small"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        onValueChange={(e) => setField({...field, valor: e.value})}
                                    />

                                    {error(field.valor, 'required')}
                                </ContainerGroupForm>}

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        value={field.estado}
                                        onChange={(e) => setField({...field, estado: e.target.value})}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {error(field.estado, 'required')}
                                </ContainerGroupForm>
                            </div>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>

        </>
    );
};

ModalNuevoDeduccion.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func
};

ModalNuevoDeduccion.defaultProps = {
    show: false,
}


